// Central env config. CRA bakes REACT_APP_* at BUILD time (static literal access only)
const config = {
  // Normalised API base (trailing slash stripped).
  SERVER_URL: (process.env.REACT_APP_SERVER_URL ?? '').replace(/\/$/, ''),

  // ALTCHA widget toggle. Build time switch, set REACT_APP_ALTCHA_ENABLED=false to drop the widget for local/test.
  // INDEPENDENT of the backend gate, must set backend APP_ENVIRONMENT=local, else it rejects the empty payload with 403
  ALTCHA_ENABLED: process.env.REACT_APP_ALTCHA_ENABLED !== 'false',
} as const;

export default config;
